import { render, staticRenderFns } from "./RegionTreeCom.vue?vue&type=template&id=3dade174&scoped=true"
import script from "./RegionTreeCom.vue?vue&type=script&lang=js"
export * from "./RegionTreeCom.vue?vue&type=script&lang=js"
import style0 from "./RegionTreeCom.vue?vue&type=style&index=0&id=3dade174&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dade174",
  null
  
)

export default component.exports